import * as React from 'react';
import { UIBasic, IPropsBasic } from 'kts-scaffold-framework/modules';
import { connect } from 'kts-platform-frame/redux';
import ReduxState, { } from 'kts-platform-frame/redux/ReduxState';
import ModulesState from './Modules.State';
import ModulesAction from './Modules.Action';
import { Select, Menu, Dropdown } from 'antd';
import PrintingButton from './Components/PrintingButton';
// import { Link } from 'react-router-dom';
const { Option } = Select;

const css = require('./index.scss');

/** Redux接口 */
interface IReduxStatePart {

}

/** Props接口 */
interface IProps extends IReduxStatePart, IPropsBasic {

}

/** 绑定全局数据到props */
@ModulesAction.uiconnect
@connect((state: ReduxState): IReduxStatePart => ({

}))
export default class UIComponents extends UIBasic<IProps, ModulesState> {

    constructor(props: IProps) {
        super(props, ModulesAction);
    }

    headOptionHandler = (v) => {
        console.log(v.key);
        if (v.key === '1') {
            // this.submitHandler('save');
            // console.log(this.modulesState.selectedRowKeys);
        } else if (v.key === '2') { 
            // ModulesAction.drawerVisibleChange(true);
        }
    }
    render() {
        const menu = (
            <Menu onClick={this.headOptionHandler}>
                <Menu.Item key={1}>
                    <PrintingButton elId={'printingId'} className={css.printingMenu}>打印</PrintingButton>
                </Menu.Item>
                {/* <Menu.SubMenu key={2} title={<div className={css.optionMenu}>分享</div>}>
                    <Menu.Item key={3}>
                        <div className={css.optionMenu}>复制分享链接</div>
                    </Menu.Item>
                </Menu.SubMenu> */}
            </Menu>
        );
        return (
            <div className={css.head}>
                <div className={css.headTop}>
                    <img src={require('./Components/Icon/img.logo.svg')} height={25} alt="" />
                    <img src={require('./Components/Icon/user.svg')} height={25} alt="" onClick={ModulesAction.goLogin}/>
                </div>
                <div className={css.headOperation}>
                    <div className={css.title}>发票预览</div>
                    <div className={css.btnBox}>
                        <a className={css.btn} href={this.modulesState.downloadUrl} download="">下载</a>
                        {/* <Dropdown overlay={menu} placement="bottomRight">
                            <div className={css.btn} style={{backgroundColor: '#000000'}}>更多</div>
                        </Dropdown> */}
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/display/modules/Home/PreviewPublic/UI.Head.tsx